import { ICheckout } from './Interfaces/ILogin';
import { Subject } from 'rxjs';

export class HelperService {
 public showDeliveryAddress: boolean = false;
 public checkoutDetails: ICheckout;
 public changecheckoutValue = new Subject<void>();
 public changeDeliveryAddress = new Subject<void>();
}
